module.exports = __webpack_public_path__ + "media/images/diy/bg-shape-1-82962271bb9f796b04000b0afa045947.svg";